import LayoutField from '@rjsf/core';

export const fields = {
  layout: LayoutField,
};

export const fileUploadFormSchema = {
  type: 'object',
  required: ['evidences'],
  properties: {
    evidences: {
      type: 'array',
      title: 'Attach Supporting Documents',
      items: {
        type: 'string',
      },
    },
  },
};

export const fileUploadUISchema = {
  evidences: {
    'ui:options': {
      orderable: false,
      removable: true,
    },
    items: {
      'ui:field': 'attachmentField',
    },
  },
};
